import React from 'react';
import classnames from 'classnames';
import { DEFAULT_CLASS_NAME, DEFAULT_TRANSPARENT } from './constants';
import type { IconButtonProps } from './types';

import classes from './IconButton.module.scss';

export const IconButton = ({
  children,
  transparent = DEFAULT_TRANSPARENT,
  className = DEFAULT_CLASS_NAME,
}: IconButtonProps) => {
  const buttonClassName = classnames(className, classes.button, { [classes.transparent]: transparent });

  return <button className={buttonClassName}>{children}</button>;
};
